export enum View {
  DAY,
  WEEK,
  MONTH,
  YEAR,
  LIST
}
